import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';
import { createStructuredSelector } from 'reselect';
import axios from 'axios';
import { Card, Row, Col, Form, Button, Icon, Input, Select, message, Typography, Modal, Layout} from 'antd';
import * as etiquetas from '../../ApplicationResources';
import TemplateExterno from '../interfaz/TemplateExterno';
import {valueUpperCase} from '../../utils/funciones.js';
import claveContacto from '../../img/modal_contacto.png';
import estadoContacto from '../../img/contactoJDE.png';
import errorImgModal from '../../img/error_icon.svg';
import { selectProceso } from '../../redux/menu/menu-selectors';
import { obtieneEstados, obtieneProcesosDetalle } from '../../redux/menu/menu-utils';
import HeaderModule from '../interfaz/Elements/HeaderModule';
const {Footer} = Layout;
const { Item } =Form;
const { Option } = Select;
const { Text } = Typography;

let msjError = "";

class ModificaCorreoComponent extends React.Component {

    constructor(props) {
        // Calling the constructor of
        // Parent Class React.Component
        super(props);

        // Setting the initial state
        this.state = {
            idProcesoElectoral: 0,
            idDetalleProceso: 0,
            idCorte : 0,
            estados:null,
            lstEstados: null,
            lstProcesos: null,
			modalContactoVisible: false,
            modalContactoInfo : [],
            modalContactoClave: false,
            botonContactoActivo: false,
            msjError: "",
            abrirModalError: false,
            disabledTxtSeccion : true
        };
    }

    componentWillMount() {
        this.setState({botonContactoActivo: false});

        // Ejecutamos la carga inicial de estados y procesos
        this.cargaInicialEstadosProcesos();
    }

    limpiarComboProceso = () =>{
        this.props.form.setFieldsValue({'idDetalleProceso': undefined});
        this.setState({lstProcesos : null});
    }

    limpiarSeccionElectoral = () => {
        this.props.form.setFieldsValue({'seccion': undefined});
    }

    // Función que ejecuta la carga inicial de los combos de proceso y entidad
    cargaInicialEstadosProcesos = () => {
        // Llamamos la función que obtiene la lista de estados
        this.getEstados().then(response => {
          // Almacenamos temporalmente la lista para eliminar el primer elemento
          var listaEstados = response;
          // Se elimina elemento 0 (TODOS)
          listaEstados.shift();
  
          // Actualizamos la lista de estados que se usa en el control Select
          this.setState({lstEstados : listaEstados});  
        });
    }

    // Función que obtiene la lista de estados desde el servicio o del wizard si ya hay datos
    getEstados = async () => {  
        // Consultamos los estados desde el servicio
        const estados = await obtieneEstados(0, 0, "D", 0, 0, 0, "ROL");

        this.setState({estados: estados});
  
        return Object.values(estados);
    }

    // Función que obtiene la lista de procesos desde el servicio o del wizard si ya hay datos
    getProcesos = async(idEstado) => {  
        if(!this.state.estados[idEstado].procesos) {
          // Consultamos los procesos desde el servicio
          const procesos = await obtieneProcesosDetalle(idEstado, 0, 0, "F");
          // Actualizamos la lista de procesos participantes en el estado seleccionado
          this.state.estados[idEstado].procesos = procesos;
        }
  
        return Object.values(this.state.estados[idEstado].procesos);
      }

    // Función que se ejecuta al seleccionar una entidad del combo
    handleCmbEstado = (value, source) => {
        // Limpieza de controles
        this.limpiarComboProceso();
        this.limpiarSeccionElectoral();

        // Llamamos la función que obtiene la lista de procesos
        this.getProcesos(value).then(response => {
          // Almacenamos temporalmente la lista de procesos para eliminar el primer elemento
          var listaProcesos = response;
          // Se elimina el elemento 0 (TODOS)
          listaProcesos.shift();
          this.setState({lstProcesos : listaProcesos});
        });
    }

    // Función que se ejecuta al seleccionar un proceso del combo
    handleCmbDetalleProceso = (value, source) => {  
        const idEstado = this.props.form.getFieldValue('idEstado');

        this.limpiarSeccionElectoral();

        this.setState({
            idProcesoElectoral : this.state.estados[idEstado].procesos[value].idProcesoElectoral,
            idDetalleProceso : this.state.estados[idEstado].procesos[value].idDetalleProceso,
            idCorte : this.state.estados[idEstado].procesos[value].corte
        });
    }

    /*
	 *Obtiene los datos de la JDE donde el aspirante puede comunicarse en caso de tener dudas
	*/
    handleContactoJDEClick = (e) => {
        const idProcesoElectoral = this.state.idProcesoElectoral;
        const idDetalleProceso = this.state.idDetalleProceso;

        e.preventDefault();
        this.props.form.validateFields((errors, values) => {
            if (!errors) {
                axios.post(process.env.REACT_APP_API_URL + '/centralReclutaSEyCAE/ws/contactoJDE'
                ,{
                    claveElectorFuar : this.props.form.getFieldValue('claveElectorFuar'),
                    idEstado : this.props.form.getFieldValue('idEstado'),
                    idProcesoElectoral:idProcesoElectoral,
                    idDetalleProceso:idDetalleProceso,
                    idCorte : this.state.idCorte,
                    correoElectronico: this.props.form.getFieldValue('correoElectronico')
                },{
                    headers: {
                        'Accept': 'application/json'
                        ,'Content-Type': 'application/json'
                    }
                },
                ).then(response => {
                    if(response.data){
                        if(response.data.length === 1){
                            this.setState({ modalContactoVisible : true,
                                            modalContactoInfo : response.data,
                                            modalContactoClave : true
                                });
                        } else {
                            this.setState({ modalContactoVisible : true,
                                            modalContactoInfo : response.data,
                                            modalContactoClave : false
                                });         
                        }
                    }
                }).catch(error => {
                    console.error("Error al consultar contacto en ModificaCorreo", error);
                    if (error.response){
                        if (error.response.status === 409){
                            msjError = error.response.data.message;
                        } else if (error.response.data && error.response.data.causa
                                        && error.response.data.causa.includes("errores")){
                        } else {
                            msjError = etiquetas.gral_error_contacto;
                        }
                    } else {
                        msjError = etiquetas.gral_error_contacto;
                    }
                    this.setState({msjError: msjError, abrirModalError: true});
                });
            }
        });
    }

	handleContactoJDEClose = () => {
        this.setState({ modalContactoVisible : false });
    }

    cerrarErrorModal() {
        this.setState({abrirModalError:false});
    }

    onChangeClaveElectorFuar = () => {
        this.props.form.setFieldsValue({'correoElectronico': undefined});
    }

    render() {
        const { getFieldDecorator, getFieldsError, isFieldTouched } = this.props.form;
        const contacto = this.state.modalContactoInfo.map((item) =>
            <li className="vinetaContacto"><p className="text_junta"><b id="titulo_junta">{item.nombreJunta}</b><br/>
                <Icon id="icon-contacto" type="user" theme="outlined"/><b>Responsable: </b>{
                    item.tratamiento + " " + item.nombres + " " +
                    (item.primerApellido !== null ? item.primerApellido : "") + " " + (item.segundoApellido !== null ? item.segundoApellido : "")
                }<br/>
                <Icon id="icon-contacto" type="environment" theme="outlined"/><b>Domicilio: </b>{
                    "Calle " + item.calle + ", No. Exterior " + item.numeroExterior + 
                    (item.numeroInterior !== null ? ", No. Interior " + item.numeroInterior : "") +
                    ", Col. " + item.colonia + ", C.P. " + item.codigoPostal +
                    ", " + item.nombreMunicipio + ", " + item.nombreEstado + "."
                } <br/>
                {
                    item.referencias ? 
                    <>
                        <Icon id="icon-contacto" type="environment" theme="outlined"/><b>Referencias: </b>{item.referencias} <br/>
                    </> 
                    : null
                }
                <Icon id="icon-contacto" type="phone" theme="outlined" rotate={90}/><b>Teléfono: </b> {item.telefono !== null && item.telefono !== "null" ? item.telefono + (item.extension ? ' ext. ' + item.extension : '') : ""} <br/>
                <Icon id="icon-contacto" type="mail" theme="outlined"/><b>Correo electrónico: </b> {item.correo} <br/></p>
                {this.state.modalContactoInfo && this.state.modalContactoInfo.length > 1 ? <hr /> : ""}
            </li> ) || {};

        return(
            <TemplateExterno enlaces={true}>
                <Row>
                    <Col sm={24} md={24} lg={24}>
                        <HeaderModule title={etiquetas.contacto_label_datos_junta_distrital} />
                    </Col>
                </Row>
                <Form
                    layout='horizontal'
                    labelAlign='left'
                    colon={true}
                    onSubmit={this.handleSubmit}>

                    <Card bordered={false}>
                        <Text style={{color: '#1890ff'}}>
                            <Icon type="info-circle" theme="filled" style={{fontSize: '1.0em'}} /> Indicaciones:<br />
                            <ul>
                                <li style={{marginLeft: '35px'}}>Para ver la información de la Junta Distrital de tu localidad, selecciona los datos de la entidad y el proceso.</li>
                                <li style={{marginLeft: '35px'}}>Para consultar la Junta Distrital donde será tu participación, incluye los datos de la clave de elector, OCR o SIAP y el correo electrónico de registro.</li>
                            </ul>
                            
                        </Text>
                        <Row gutter={8}>
                            <Col sm={24} md={12} lg={12}>
                                <Item
                                    label={etiquetas.modifica_correo_lbl_estado}
                                    required={true}>
                                    {getFieldDecorator('idEstado', {
                                        rules: [{ required: true
                                                , type: 'number'
                                                , message: this.props.form.getFieldValue('idEstado') ? etiquetas.general_formato_invalido:etiquetas.general_dato_requerido }],
                                    })(
                                        <Select placeholder={etiquetas.modifica_correo_lbl_estado}
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(value) => this.handleCmbEstado(value, 'idEstado')}
                                            >
                                            {
                                                this.state.lstEstados &&
                                                this.state.lstEstados.map((estado, index) => (
                                                    <Option key={index} value={estado.idEstado}>{estado.nombreEstado}</Option>
                                                ))
                                            }
                                        </Select>,
                                    )}
                                </Item>
                            </Col>
                            <Col sm={24} md={12} lg={12}>
                                <Item
                                    label={etiquetas.modifica_correo_lbl_proceso}
                                    required={true}>
                                    {getFieldDecorator('idDetalleProceso', {
                                        rules: [{ required: true
                                                , type: 'number'
                                                , message: this.props.form.getFieldValue('idDetalleProceso') ? etiquetas.general_formato_invalido:etiquetas.general_dato_requerido }],
                                    })(
                                        <Select placeholder={etiquetas.modifica_correo_lbl_proceso}
                                            disabled={this.props.form.getFieldValue('idEstado') ? false : true}
                                            showSearch
                                            optionFilterProp="children"
                                            onChange={(value) => this.handleCmbDetalleProceso(value, 'idDetalleProceso')}
                                            >
                                            {
                                                this.state.lstProcesos &&
                                                this.state.lstProcesos.map((proceso, index) => (
                                                    <Option key={index} value={proceso.idDetalleProceso}>{proceso.descripcionDetalleLarga}</Option>
                                                ))
                                            }
                                        </Select>,
                                    )}
                                </Item>
                            </Col>
                        </Row>
                        <Row gutter={8}>
                            <Col sm={12} md={12} lg={12}>
                                <Item
                                    label={etiquetas.modifica_correo_lbl_claveElectorFuar}
                                    required={false}>
                                    {getFieldDecorator('claveElectorFuar', {
                                        getValueFromEvent: valueUpperCase,
                                        rules: [{ required: false
                                                , whitespace: false
                                                , min: 12
                                                , max: 18
                                                , pattern: etiquetas.REGEX_FORMATO_CLAVE_ELECTOR_FUAR_ANT
                                                , message: () => this.props.form.getFieldValue('claveElectorFuar') ? etiquetas.general_formato_invalido:etiquetas.general_dato_requerido }],
                                    })(
                                        <Input className="transicion_input"
                                            placeholder={etiquetas.modifica_correo_lbl_claveElectorFuar}
                                            disabled={this.props.form.getFieldValue('idDetalleProceso') === undefined ? true: false}
                                            maxLength={18}
                                            onChange={this.onChangeClaveElectorFuar}
                                            allowClear/>,
                                    )}
                                </Item>
                            </Col>

                            <Col sm={12} md={12} lg={12}>
                                <Item
                                    label={etiquetas.datos_personales_lbl_correoElectronico}
                                    required={this.props.form.getFieldValue('claveElectorFuar')}
                                    disabled={!this.props.form.getFieldValue('claveElectorFuar')}>
                                    {getFieldDecorator('correoElectronico', {
                                        rules: [{ required: this.props.form.getFieldValue('claveElectorFuar')
                                                , disabled: !this.props.form.getFieldValue('claveElectorFuar')
                                                , whitespace: false
                                                , min: 1
                                                , max: 50
                                                , pattern: etiquetas.REGEX_FORMATO_CORREO
                                                , message: () => this.props.form.getFieldValue('correoElectronico') ? etiquetas.general_formato_invalido:etiquetas.general_dato_requerido }],
                                    })(
                                        <Input className="transicion_input"
                                            required={this.props.form.getFieldValue('claveElectorFuar')}
                                            disabled={!this.props.form.getFieldValue('claveElectorFuar')}
                                            placeholder={etiquetas.datos_personales_lbl_correoElectronico}
                                            maxLength={50}
                                            allowClear/>,
                                    )}
                                </Item>
                            </Col>
                        </Row>
                    </Card>
                    <Footer>
                        <Row type="flex" justify="center">
                            <Col span={24} style={{textAlign:'center'}}>
                                <Button type="primary"
                                            id="button_correo"
                                            disabled={this.props.form.getFieldValue('idDetalleProceso') === undefined ? true: false}
                                            onClick={this.handleContactoJDEClick}>
                                        Contacto
                                    </Button>
                            </Col>
                        </Row>
                    </Footer>
                </Form>
                <Modal
                    visible={this.state.modalContactoVisible}
                    title={null}
					centered={true}
					onOk={this.handleContactoJDEClose}
                    onCancel={this.handleContactoJDEClose}
                    footer={null}
                    className="modal_contacto"
                >
                {this.state.modalContactoClave ?
                    <div id="modal_clave">
                        <div id="modal_estado_titulo">
                            Datos de contacto
                        </div>
                        <div id="modal_estado_informacion">
                            Para aclarar tus dudas, puedes comunicarte vía telefónica, enviar un<br />correo electrónico o asistir directamente a la Junta Distrital Ejecutiva
                        </div>
                        <hr id="modal_estado_linea" />
                        <Col xs={24} sm={6} md={12} lg={10}>
                            <div id="modal_contactoImgClave">
                                <img src={claveContacto} />
                            </div>
                        </Col>
                        <Col xs={24} sm={6} md={12} lg={12}>
                            {contacto}
                        </Col>
                    </div> :
                    <div id="modal_estado">
                        <div id="modal_estado_titulo">
                            Datos de contacto
                        </div>
                        <div id="modal_estado_informacion">
                            Para aclarar tus dudas, puedes comunicarte vía telefónica, enviar un<br />correo electrónico o asistir directamente a la Junta Distrital Ejecutiva
                        </div>
                        <hr id="modal_estado_linea" />
                        <Col xs={24} sm={6} md={12} lg={10}>
                            <img src={estadoContacto} id="modal_contactoImgEstado"/>
                        </Col>
                        <Col xs={24} sm={6} md={12} lg={12}>
                            <div className="lstJuntas">
                                {contacto}
                            </div>
                        </Col>
                    </div>
                }
                </Modal>
                <Modal className="modalError"
                       title={<img  src={errorImgModal} id="img-error-modal"/>}
                       centered
                       onCancel={()=>this.cerrarErrorModal()}
                       visible={this.state.abrirModalError}
                       footer={false}
                       width={400}>
                    {this.state.msjError}
                </Modal>
            </TemplateExterno>
        );
    }
};

const mapStateToProps = createStructuredSelector({
    proceso: selectProceso
});

export default withRouter(connect(mapStateToProps)(Form.create({ name: 'modificaCorreoComponent' })(ModificaCorreoComponent)));
